import { useCallback, useEffect, useState } from 'react';
import { Button, IconButton, makeStyles, Popover, Tooltip } from "@material-ui/core";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useHistory, useLocation } from "react-router-dom";
import CreatorBtn from "../../../../atoms/creator/experienceBuilderEnterBtn";
import ChipInput from 'material-ui-chip-input'
import CSVReader from 'react-csv-reader'
import { useDispatch, useSelector } from "react-redux";
import CreatorInviteParticipantModal from '../../../../atoms/modals/inviteParticipantModal';
import { moveNextPage, updateUserMetrics } from "../../../../../store/actions/creator/creatorExperienceBuilder";
import Config from "../../../../../config/config";
import CustomSnackBar from '../../experienceManager/participantsDashboard/component/CustomSnackBar';
import UtilService from "../../../../../helper/service";
import { CSVLink } from "react-csv";
import Messages from "../../../../../helper/messages"
import {useFocusWithin} from '@react-aria/interactions';

const useStyles = makeStyles(() => ({
  mainTitle: {
    fontSize: 48,
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textAlign: 'center',
    marginTop: '10px!important',
    marginBottom: '30px!important',
    '@media only screen and (max-width: 600px)': {
      fontSize: 20
    }
  },
  subTitle: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    fontSize: 24,
    color: '#212D40',
    marginTop: '30px!important',
    marginBottom: '15px!important'
  },
  infoIcon: {
    width: 24,
    height: 24,
    cursor: 'pointer',
    marginTop: '1px',
    marginLeft: 6
  },
  sessionCode: {
    fontSize: 40,
    fontFamily: 'roboto-black',
    color: '#697683'
  },
  label: {
    "&$focusedLabel": {
      color: "#707070"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {
    fontSize: 14,
    fontFamily: 'roboto-black',
  },
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#8F99A3',
    width: "100%",
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  error: {},
  addBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#F0F0F0',
    color: '#697683',
    marginTop: 16
  },
  addBlueBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#017AEF',
    color: '#fff',
    marginTop: 16,
    "&:hover": {
      backgroundColor: '#0f9fef',
    }
  },
  linkPanel: {
    fontSize: 18,
    fontFamily: 'roboto-black',
    color: '#697683'
  },
  link: {
    color: '#017AEF',
    textDecoration: 'none',
    '&:hover': {
      color: '#0f9fef'
    }
  },
  participants: {
    fontSize: 18,
    fontFamily: 'roboto-black',
    color: '#017AEF',
    alignItems: 'center',
    display: 'inline-flex',
    cursor: 'pointer',
    '&:hover': {
      color: '#0f9fef'
    }
  },
  participantsIcon: {
    width: 24,
    height: 24
  },
  csvPanel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20
  },
  sendinvitebtn: {
    textTransform: 'none',
    backgroundColor: '#0179EE',
    color: '#FFFFFF',
    fontFamily: 'roboto-regular',
    borderRadius: 6,
    boxShadow: 'none',
    width: 120,
    height: 37
  },
  csvBtn: {
    width: 100,
    height: 37,
    borderRadius: 4,
    marginLeft: 10,
    textTransform: 'none',
    backgroundColor: '#F0F0F0',
    fontSize: '0.875rem',
    fontFamily: 'roboto-regular',
    color: '#697683',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    '& input': {
      display: 'none'
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#e0e0e0',
    },
  },
  csvLabel: {
    cursor: 'pointer',
    padding: 8
  },
  doneBtn: {
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 6,
    backgroundColor: '#0179EE',
    width: 91,
    height: 37,
    fontSize: 14,
    fontFamily: 'roboto-regular'
  },
  cancelBtn: {
    textTransform: 'none',
    marginRight: 20,
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  checkbox: {
    padding: 5,
    marginRight: 15,
    borderRadius: 5,
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#0082ff26',
    },
  },
  icon: {
    borderRadius: 3,
    width: 24,
    height: 24,
    backgroundColor: '#f5f8fa'
  },
  checkboxLabel: {
    fontFamily: 'roboto-bold',
    fontSize: 24,
    color: '#212D40',
  },
  downloadicon: {
    marginLeft: 10,
    borderRadius: 5,
    background: '#F0F0F0',
    '&:hover': {
      background: '#e0e0e0',
      borderRadius: 5
    },
    height: 37,
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  },
  p7: {
    padding: 7
  },
  checkDescription: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  anchor: {
    color: '#0179EE',
    textDecoration: 'none'
  },
  popover: {
    marginLeft: 15
  },
  popoverDiv: {
    fontFamily: 'roboto-regular',
    fontSize: 12,
    padding: 15,
    background: '#F0F0F0',
    color: '#212D40',
    maxWidth: 300,
    lineHeight: '15px'
  },
  bold: {
    fontFamily: 'roboto-bold'
  },
  helpLink: {
    color: '#017AEF',
    textDecoration: 'none'
  }
}));

function ReelsInviting() {
  const classes = useStyles();
  const parseOptions = {
    header: false,
    skipEmptyLines: true
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userMetrics, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const {
    asyncCSVName, asyncParticipants, sessionCode, listsParticipants, addParticipantList, reelsLastActivePage,
    createReel, asyncLastActivePage
  } = userMetrics;
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [anchorEl3, setAnchorEl3] = useState(null);
  const [copied, setCopied] = useState(false);
  const [sessionCodeCopied, setSessionCodeCopied] = useState(false);
  const [emails, setEmails] = useState<string[]>([]);
  const [modal, setModal] = useState(false);
  const [errorEmailIndex, setErrorEmailIndex] = useState(-1);
  const [participantsAddedImg, setParticipantsAddedImg] = useState("/assets/icons/experiencebuilder/participants_added.svg");
  const [snackAlertType, handleSnackAlertType] = useState('');
  const [snackAlertMsg, handleSnackMsg] = useState('');
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [showNextBtn, setShowNextBtn] = useState(false);
  const [csvData, handleCsvData] = useState<any[]>([]);
  const [randomID, setRendomId] = useState(1);
  const [focus, setFocus] = useState(false);

  const { focusWithinProps } = useFocusWithin({
    onFocusWithin: () => setFocus(true),
    onBlurWithin: () => setFocus(false),
  });
  const open1 = Boolean(anchorEl1);
  const id1 = open1 ? 'simple-popover' : undefined;
  const open2 = Boolean(anchorEl2);
  const id2 = open2 ? 'simple-popover' : undefined;
  const open3 = Boolean(anchorEl3);
  const id3 = open3 ? 'simple-popover' : undefined;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'invite');
    setTimeout(() => {
      setShowNextBtn(true);
    }, 2000);
  }, []);

  useEffect(() => {
    if (!addParticipantList && listsParticipants.length > 0) {
      addListsParticipants();
    }
  }, [addParticipantList, listsParticipants]);

  const addListsParticipants = useCallback(() => {
    const newParticipants: any[] = [];
    const _listsParticipants = [...listsParticipants];
    if (asyncParticipants.length > 0) { // already added participants exist
      _listsParticipants.forEach((lp: any) => {
        for (let i = 0; i < asyncParticipants.length; i++) {
          if (lp.email === asyncParticipants[i].email) {
            return;
          }
        }
        newParticipants.push({
          email: lp.email,
          tags: UtilService.getParsedTags(lp.tags),
          is_csv: false
        });
      });
    } else {
      _listsParticipants.forEach((lp: any) => {
        newParticipants.push({
          email: lp.email,
          tags: UtilService.getParsedTags(lp.tags),
          is_csv: false
        })
      })
    }
    dispatch(updateUserMetrics('asyncParticipants', asyncParticipants.concat(newParticipants)));
  }, [asyncParticipants, listsParticipants]);

  const handleModal = () => {
    const errorEmailIndex = asyncParticipants.findIndex((item: any) => !emailValidate(item.email));
    if (errorEmailIndex < 0) {
      setModal(!modal);
      setErrorEmailIndex(-1);
    } else {
      setErrorEmailIndex(errorEmailIndex)
    }
  };

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13 && !focus) {
      goNext();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  const goNext = () => {
    const nextPage = page + 1;
    if (emails.length > 0) {
      onAddParticipants(emails, false);
    }
    dispatch(updateUserMetrics('listsParticipants', []));
    dispatch(moveNextPage(nextPage));
    if (createReel) {
      (nextPage > asyncLastActivePage) && dispatch(updateUserMetrics('asyncLastActivePage', nextPage));
    } else {
      (nextPage > reelsLastActivePage) && dispatch(updateUserMetrics('reelsLastActivePage', nextPage));
    }
  };

  const handleAddEmail = (email: string) => {
    setEmails(emails => [...emails, email]);
  };

  const handleDeleteEmail = (_: any, index: number) => {
    setEmails(emails => emails.filter((_: any, _index) => _index !== index))
  };

  const emailValidate = (email: string) => {
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return validEmail.test(email);
  };

  const showErrorAlert = (message: string) => {
    handleSnackMsg(message);
    handleSnackAlertType('error');
    setShownSnackAlert(true);
  };

  const handleBeforeAddEmail = (email: string) => {
    if (asyncParticipants.length === 0) {
      if (!emailValidate(email)) {
        showErrorAlert('Invalid email');
      }
      return emailValidate(email);
    }
    return checkUserMetricsEmails(email);
  };

  const checkUserMetricsEmails = (email: string) => {
    const existParticipants = [...asyncParticipants];
    const existEmails = existParticipants.map((p: any) => p['email']);
    if (existEmails.indexOf(email) === -1) {
      if (!emailValidate(email)) {
        showErrorAlert('Invalid email');
      }
      return emailValidate(email);
    }
    showErrorAlert('Email exist already');
    return false;
  };

  const handleForceCSV = (rows: any, fileInfo: any) => {
    let check = 0;
    const array = ['application/vnd.ms-excel', 'text/plain', 'text/csv', 'text/tsv'];
    if (array.indexOf(fileInfo.type) === -1) {
      handleSnackMsg(Messages.NOTIFICATIONS.ERROR.csvFileValidation);
      handleSnackAlertType("error");
      setShownSnackAlert(true);
      return
    }
    const csvValidEmails: any[] = [...asyncParticipants];
    rows.forEach((row: any) => {
      const email = row[0] ? row[0].toLowerCase().trim() : '';
      if (emailValidate(email) && !csvValidEmails.find((obj) => obj.email === email)) {
        const tags = row[1] ? row[1].trim() : '';
        csvValidEmails.push({ email, tags, is_csv: true });
        check++;
        if (email.startsWith("brainiac")) {
          dispatch(updateUserMetrics('updateBraintrustMetrics', true));
        }
      }
    });

    if (check === 0) {
      handleSnackMsg(Messages.NOTIFICATIONS.ERROR.csvFileValidation);
      handleSnackAlertType("error");
      setShownSnackAlert(true);
      return
    }

    onAddParticipants(csvValidEmails, true);
    dispatch(updateUserMetrics('asyncCSVName', fileInfo.name));
    setRendomId(randomID + 1)
  };

  const onAddParticipants = (_emails: any, isCSV: boolean) => {
    const emailParticipate: any = [];
    if (!isCSV && _emails) {
      _emails.forEach((row: any) => {
        emailParticipate.push({ email: row, tags: '', is_csv: false })
      });
    }
    dispatch(updateUserMetrics('asyncParticipants', isCSV ? _emails : asyncParticipants.concat(emailParticipate)));
    if (!isCSV) {
      setEmails([])
    }
  };

  const onBlurAddEmail = (event: any) => {
    if (event.target.value) {
      if (handleBeforeAddEmail(event.target.value) && !emails.includes(event.target.value)) {
        setEmails(emails => [...emails, event.target.value]);
      }
    }
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const csvHeaders = [
    { label: "Email", key: "email" },
    { label: "Tags", key: "tags" }
  ];

  const handleCSVDownload = () => {
    const tempParticipants: any = [
      { email: "brainiac01@getimmersion.com", tags: "tag1,tag2" },
      { email: "brainiac02@getimmersion.com", tags: "tag3,tag4," },
      { email: "brainiac03@getimmersion.com", tags: "tag5" }
    ];
    handleCsvData(tempParticipants);
  };

  const handleClose = () => {
    setAnchorEl1(null);
    setAnchorEl2(null);
    setAnchorEl3(null);
  };

  const onAddParticipantList = () => {
    dispatch(updateUserMetrics('addParticipantList', true));
  };

  return (
    <div>
      <p className={classes.mainTitle}>
        Invite participants however is easiest
      </p>
      <div className='creator-main-panel' style={{ marginBottom: -25 }}>
        <p className={classes.subTitle}>
          Let Immersion send invites & instructions
          <img
            className={classes.infoIcon}
            alt="Info"
            src={'/assets/icons/info.svg'}
            onClick={(e: any) => setAnchorEl1(e.currentTarget)}
          />
          <Popover
            id={id1}
            open={open1}
            anchorEl={anchorEl1}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            className={classes.popover}
          >
            <div className={classes.popoverDiv}>
              <span className={classes.bold}>Add your participants’ email address below.</span>
              Our system will send them an email with instructions once you take your event live. Your results will still be anonymous.
            </div>
          </Popover>
        </p>
        <div
          style={{ margin: "auto", justifyContent: "center", display: "flex", alignItems: "center", marginBottom: 10 }} {...focusWithinProps}>

          <ChipInput
            value={emails}
            onBeforeAdd={(email) => handleBeforeAddEmail(email)}
            onAdd={(email) => handleAddEmail(email)}
            onDelete={(email, index) => handleDeleteEmail(email, index)}
            style={{ flex: 14 }}
            id="emails"
            label="Type email address and press space or comma"
            newChipKeyCodes={[13, 32, 188]}
            newChipKeys={[]}
            InputLabelProps={{
              classes: {
                root: classes.label,
                focused: classes.focusedLabel,
                error: classes.erroredLabel
              },
            }}
            InputProps={{
              classes: {
                root: classes.underline,
                error: classes.error
              }
            }}
            onBlur={(event) => onBlurAddEmail(event)}
          />
          &nbsp;&nbsp;&nbsp;
          <Button variant="contained" className={emails && emails.length ? classes.addBlueBtn : classes.addBtn}
            onClick={() => onAddParticipants(emails, false)}>Add</Button>
        </div>
        <div className={classes.csvPanel}>
          <Button className={classes.csvBtn} style={{ width: 'auto', marginLeft: 0 }} onClick={onAddParticipantList}>
            Add a Participant List
          </Button>
          <div key={randomID}>
            <CSVReader
              cssClass={classes.csvBtn}
              cssLabelClass={classes.csvLabel}
              label="Upload CSV"
              onFileLoaded={handleForceCSV}
              parserOptions={parseOptions}
            />
          </div>
          <CSVLink data={csvData} headers={csvHeaders} onClick={handleCSVDownload} filename={`sample_participants.csv`}>
            <div className={classes.downloadicon}>
              <Tooltip title="Download CSV Template" placement="bottom">
                <IconButton aria-label="download" className={classes.p7} size="medium">
                  <img src={'/assets/icons/download_icon.svg'} alt="CSV Download" />
                </IconButton>
              </Tooltip>
            </div>
          </CSVLink>
          {asyncCSVName && <span className={classes.participants} style={{ marginLeft: 30 }}>{asyncCSVName}</span>}
        </div>
        {asyncParticipants.length > 0 && (
          <div className={classes.participants} style={{ marginTop: 30 }} onClick={handleModal}
            onMouseOver={() => setParticipantsAddedImg("/assets/icons/experiencebuilder/participants_added2.svg")}
            onMouseOut={() => setParticipantsAddedImg("/assets/icons/experiencebuilder/participants_added.svg")}>
            <span>{asyncParticipants.length} Participants added</span>&nbsp;&nbsp;
            <span>
              <img src={participantsAddedImg} className={classes.participantsIcon}
                alt="participant"
              />
            </span>
          </div>
        )}
        <div className='separate-line'>
          <span>OR</span>
        </div>
        <p className={classes.subTitle}>
          Copy a link to share
          <img
            className={classes.infoIcon}
            alt="Info"
            src={'/assets/icons/info.svg'}
            onClick={(e: any) => setAnchorEl2(e.currentTarget)}
          />
          <Popover
            id={id2}
            open={open2}
            anchorEl={anchorEl2}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            className={classes.popover}
          >
            <div className={classes.popoverDiv} style={{ maxWidth: 400 }}>
              When participants visit the web page, they’ll get&nbsp;
              <a className={classes.helpLink} href={`${Config.COMPANY_URL}/shareable_links`} target={'_blank'} rel={'noreferrer'}>instructions for downloading</a>&nbsp;
              our app on their smartwatch and connecting. Review smartwatch compatibility&nbsp;
              <a className={classes.helpLink} href={`${Config.COMPANY_URL}/device_requirements`} target={'_blank'} rel={'noreferrer'}>here</a>.
            </div>
          </Popover>
        </p>
        <div style={{ margin: "auto", justifyContent: "center", display: "flex", alignItems: "center" }}>
          <CopyToClipboard
            text={`${Config.DEV_ASYNC_INVITE_URL}${loginUserData && loginUserData.invite_link_type === "b" ? '/participant' : ''}/${sessionCode}`}
            onCopy={() => { setCopied(true); handleSnackMsg('Link Copied'); handleSnackAlertType('success'); setShownSnackAlert(true); }}>
            <Button variant="contained" className={classes.addBtn} style={{ marginTop: 0 }} disabled={copied}>
              {copied ? 'Copied' : 'Copy'}
            </Button>
          </CopyToClipboard>
          &nbsp;&nbsp;&nbsp;
          <p className={classes.linkPanel}
            style={{ flex: 14 }}>{`${Config.DEV_ASYNC_INVITE_URL}${loginUserData && loginUserData.invite_link_type === "b" ? '/participant' : ''}/${sessionCode}`}</p>
        </div>
        <div className='separate-line'>
          <span>OR</span>
        </div>
        <p className={classes.subTitle}>
          Send participants this Experience ID#
          <img
            className={classes.infoIcon}
            alt="Info"
            src={'/assets/icons/info.svg'}
            onClick={(e: any) => setAnchorEl3(e.currentTarget)}
          />
          <Popover
            id={id3}
            open={open3}
            anchorEl={anchorEl3}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            className={classes.popover}
          >
            <div className={classes.popoverDiv}>
              Your participants can manually enter this in the Immersion App on their phone.
            </div>
          </Popover>
        </p>
        <div style={{ margin: "auto", justifyContent: "center", display: "flex", alignItems: "center" }}>
          <CopyToClipboard
            text={`${sessionCode}`}
            onCopy={() => { setSessionCodeCopied(true); handleSnackMsg('Session Code Copied'); handleSnackAlertType('success'); setShownSnackAlert(true); }}>
            <Button variant="contained" className={classes.addBtn} style={{ marginTop: 0 }} disabled={sessionCodeCopied}>
              {sessionCodeCopied ? 'Copied' : 'Copy'}
            </Button>
          </CopyToClipboard>
          &nbsp;&nbsp;&nbsp;
          <span className={classes.sessionCode} style={{ flex: 14 }}>{`${sessionCode}`}</span>
        </div>
      </div>

      <CreatorInviteParticipantModal
        open={modal}
        onClose={handleModal}
        data={asyncParticipants}
        errorEmailIndex={errorEmailIndex}
      />
      {showNextBtn && <CreatorBtn goNext={goNext} title={'Proceed to Review'} isRight={true} />}
      <br /><br />

      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
    </div>
  )
}

export default ReelsInviting;